import React, { PropsWithChildren } from 'react'
import { Box, Heading, Text } from '@workwhile/ui'

type IssueSectionProps = PropsWithChildren<{
  title: string
  description: string
  emptyMessage: string
  isEmpty: boolean
}>

export const IssueSection = ({
  title,
  description,
  emptyMessage,
  isEmpty,
  children,
}: IssueSectionProps) => {
  return (
    <Box mb={4}>
      <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
        {title}
      </Heading>
      <Text color="lightText" mb={2} mt={1}>
        {description}
      </Text>
      {isEmpty ? <Text color="lightText">{emptyMessage}</Text> : children}
    </Box>
  )
}
